import { render } from "./talent.vue?vue&type=template&id=2fd7f6eb&scoped=true"
import script from "./talent.vue?vue&type=script&lang=js"
export * from "./talent.vue?vue&type=script&lang=js"

import "./talent.vue?vue&type=style&index=0&id=2fd7f6eb&lang=css&scoped=true"

import exportComponent from "/var/www/mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd7f6eb"]])

export default __exports__